import { InspectionCase } from './inspection-case.dto';

export class InspectionAlarmtCaseDto extends InspectionCase {
  nameAndLocation?: string;
  accessory?: string;
  address?: string;
}
export class InspectionAlarmtCase extends InspectionAlarmtCaseDto {
  constructor(
    data: InspectionAlarmtCaseDto = { isApplicable: true, isPassed: true }
  ) {
    super(data);
    this.nameAndLocation = data.nameAndLocation;
    this.accessory = data.accessory;
    this.address = data.address;
  }
}
